import { render } from "./AsteriskSymbol.vue?vue&type=template&id=ee4f65ea"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__